function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.3165 18.4799V16.8199H5.87646V18.4799H10.6965V30.9999H12.5165V18.4799H17.3165Z",
  fill: "black"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.8788 30.9999L24.9388 22.4199L29.8588 16.8199H27.6588L21.2788 24.0999V16.8199H19.4788V30.9999H21.2788V26.5999L23.6788 23.8599L27.7788 30.9999H29.8788Z",
  fill: "black"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M41.0412 24.0399C41.0412 21.3599 40.8012 19.3999 39.4012 17.9799C38.7212 17.2999 37.7812 16.8199 36.4012 16.8199C35.0212 16.8199 34.0812 17.2999 33.4012 17.9799C32.0012 19.3999 31.7612 21.3599 31.7612 24.0399C31.7612 26.7199 32.0012 28.6599 33.4012 30.0799C34.0812 30.7599 35.0212 31.2599 36.4012 31.2599C37.7812 31.2599 38.7212 30.7599 39.4012 30.0799C40.8012 28.6599 41.0412 26.7199 41.0412 24.0399ZM38.8012 19.9999L33.5812 26.3999C33.5012 25.6399 33.5212 24.8199 33.5212 24.0399C33.5212 22.1599 33.5012 20.1199 34.6812 18.9999C35.0812 18.6199 35.6612 18.3599 36.4012 18.3599C37.1412 18.3599 37.7212 18.6199 38.1212 18.9999C38.4212 19.2799 38.6412 19.6199 38.8012 19.9999ZM39.2812 24.0399C39.2812 25.9199 39.3012 27.9599 38.1212 29.0799C37.7212 29.4599 37.1412 29.7199 36.4012 29.7199C35.6612 29.7199 35.0812 29.4599 34.6812 29.0799C34.4212 28.8399 34.2212 28.5399 34.0612 28.1999L39.2212 21.8199C39.2812 22.5399 39.2812 23.2999 39.2812 24.0399Z",
  fill: "black"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2 1H46V-1H2V1ZM47 2V46H49V2H47ZM46 47H2V49H46V47ZM1 46V2H-1V46H1ZM2 47C1.44772 47 1 46.5523 1 46H-1C-1 47.6569 0.343147 49 2 49V47ZM47 46C47 46.5523 46.5523 47 46 47V49C47.6569 49 49 47.6569 49 46H47ZM46 1C46.5523 1 47 1.44772 47 2H49C49 0.343145 47.6569 -1 46 -1V1ZM2 -1C0.343145 -1 -1 0.343147 -1 2H1C1 1.44772 1.44772 1 2 1V-1Z",
  fill: "#CCCCCC"
});

var SvgTk0 = function SvgTk0(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTk0, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/TK0.ff2d2285.svg";
export { ForwardRef as ReactComponent };